import React, { useContext, useEffect, useRef, useState } from "react";
import AddVoucher from "../../API/APIServices/AddVoucher";
import Transaction from "../../API/APIServices/Transaction";
import Account from "../../API/APIServices/Account";
import UserCredential from "../../API/APIServices/UserCredential";
import MyContext from "../MyContext";
import AlertBoxError from "../Props/AlertBoxError";
import Swal from "sweetalert2";

const PayRemainingBill = ({
  isOpen,
  onClose,
  Voucherinfo,
  TransId,
  masterType,
}) => {
  const [SubmitButtonDisable, setSubmitButtonDisable] = useState(false);
  const [currenttab, setcurrenttab] = useState(0);
  const [historydata, sethistorydata] = useState([]);
  const [data, setdata] = useState({
    partyName: "",
    balanceAmt: "",
    payamount: "",
    paydate: "",
    paybyvalue: "",
    remarks: "",
    payby: [],
  });
  const { UserDetails } = useContext(MyContext);
  const id = document.getElementById(`payAmt`);

  const handlechange = (e) => {
    const { name, value } = e.target;
    ;

    if (name == "payby") {
      setdata((prev) => ({
        ...prev,
        paybyvalue: value,
      }));
      return;
    }

    setdata((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const historydatafnc = async () => {
    try {
      ;
      const history = await AddVoucher.AddPayRemainingAsyncById(
        masterType,
        TransId
      );
      if (history) {
        // const filterdata = history.filter((item) => item.paidType == 51);
        sethistorydata(history);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async () => {
    ;
    setSubmitButtonDisable(true);

    if (!data.paybyvalue) {
      setSubmitButtonDisable(false);
      return Swal.fire({
        icon: "warning",
        title: "Payment Mode Should Be Selected!",
        text: "Please choose a payment mode before proceeding.",
      });
    }

    if (parseInt(data.payamount) > parseInt(data.balanceAmt)) {
      setSubmitButtonDisable(false);
      return Swal.fire({
        icon: "warning",
        title: "Payment Amount Should Be Less Than Due Amount!",
        text: "Please check the payment amount and try again.",
      });
    }

    const body = {
      masterType: masterType,
      trans1Id: TransId,
      paidDate: data.paydate,
      payByAccId: data.paybyvalue,
      paidAmt: data.payamount,
      shortNarration: data.remarks,
    };
    const request = await AddVoucher.PayRemining(body);
    if (request) {
      console.log("result", request);
      Swal.fire({
        icon: "success",
        title: "Payment Done Successfully",
        text: "Your payment has been processed.",
      });
    }

    setSubmitButtonDisable(false);
  };

  const GetDataByTrans = async () => {
    try {
      ;
      const filter = [
        {
          fieldName: "t1.id",
          operatorName: "equal",
          compareValue: TransId,
        },
      ];
      const data1 = await Transaction.GetTransactionList(masterType, filter);
      console.log(data1);
      if (data1 && data1.length > 0) {
        const tempdata = data1[0];
        setdata({
          ...data,
          partyName: tempdata.PartyName,
          balanceAmt: parseFloat(tempdata.DueAmount),
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Add leading zero if needed
    const day = String(today.getDate()).padStart(2, "0"); // Add leading zero if needed

    const currentdata = `${year}-${month}-${day}`;
    setdata((prev) => ({
      ...prev,
      paydate: currentdata,
    }));
  };

  const GetAutoSuggetion = async () => {
    const data = {
      MasterType: 2,
      GroupWiseSuggestion: true,
      GroupId: "202,203",
      search_str: "",
      PageNumber: 1,
      PageSize: 50,
    };
    const paytype = await Account.GetAccountListForAutoSuggestion(data);
    if (paytype) {
      setdata((prev) => ({
        ...prev,
        payby: paytype,
      }));
    }
  };

  useEffect(() => {
    console.log(`voucher`, Voucherinfo);
  }, [Voucherinfo]);

  useEffect(() => {
    historydatafnc();
  }, [isOpen, TransId]);

  useEffect(() => {
    GetDataByTrans()
      .then(() => getCurrentDate())
      .then(() => GetAutoSuggetion());
  }, [TransId, isOpen]);

  const handleclose = () => {
    setdata({
      partyName: "",
      balanceAmt: "",
      payamount: "",
      paydate: "",
      remarks: "",
      payby: [],
    });
    onClose();
  };

  const deletehandle = async (masterid, trans1Id, paidremid) => {
    try {
      ;
      if (!UserDetails.canDelVoucher) {
        return Swal.fire({
          icon: "warning",
          title: "Not Allowed",
          text: "You are not allowed to delete the voucher.",
        });
      }
      const deleteaction = await AddVoucher.Addvouchersdelete(
        masterid,
        trans1Id,
        paidremid
      );
      if (deleteaction.isSuccess) {
        Swal.fire({
          icon: "success",
          title: "Delete Successful!",
          text: "Your item has been deleted.",
        });

        await historydatafnc();
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (id) {
      id.focus();
    }
  }, [id]);

  useEffect(() => {
    console.log("data", data);
  }, [data]);

  useEffect(() => {
    if (currenttab == 1) {
      historydatafnc();
    }
  }, [currenttab]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="BillBar-modal" style={{zIndex: 3}}>
      <div className="BillBar-modal-content bill-ramaining-modal">
        <div className="BillBar-modal-header payment-header">
          <h2>Payment Details</h2>

          <div className={`div-for-payment-top`}>
            <span className={`tab-for-payment`}>
              <span
                style={{
                  backgroundColor: currenttab == 0 ? "rgb(33 46 79)" : "",
                  color: currenttab == 0 ? "#fff" : "",
                }}
                onClick={() => setcurrenttab(0)}
              >
                Payment
              </span>
              <span
                style={{
                  backgroundColor: currenttab == 1 ? "rgb(33 46 79)" : "",
                  color: currenttab == 1 ? "#fff" : "",
                }}
                onClick={() => setcurrenttab(1)}
              >
                History
              </span>
            </span>

            <button
              onClick={() => handleclose()}
              className="BillBar-modal-close close-btn-pay-rem"
            >
              ✖
            </button>
          </div>
        </div>

        {currenttab == 0 ? (
          <div className="BillBar-modal-form">
            <div className="BillBar-modal-input">
              <label htmlFor="partyName">Voucher Info</label>
              <input
                type="text"
                className={`bill-remaining-input bill-remaining `}
                id="partyName"
                value={Voucherinfo}
                disabled={true}
                //   onChange={(e) => setPartyName(e.target.value)}
                placeholder="Enter Party Name"
              />
            </div>

            <div className="BillBar-modal-input">
              <label htmlFor="partyName">Party Name</label>
              <input
                type="text"
                className={`bill-remaining-input bill-remaining `}
                id="partyName"
                value={data.partyName}
                disabled={true}
                //   onChange={(e) => setPartyName(e.target.value)}
                placeholder="Enter Party Name"
              />
            </div>

            <div className="BillBar-modal-input">
              <label htmlFor="balanceAmt">Due Amount</label>
              <input
                type="number"
                id="balanceAmt"
                className={`bill-remaining-input bill-remaining`}
                value={data.balanceAmt}
                disabled={true}
                //   onChange={(e) => setBalanceAmt(e.target.value)}
                placeholder="Enter Balance Amount"
              />
            </div>

            <div className="BillBar-modal-input">
              <label htmlFor="payAmt">Pay Amount</label>
              <input
                type="number"
                id="payAmt"
                className={`bill-remaining-input bill-remaining`}
                value={data.payamount}
                name="payamount"
                onChange={(e) => handlechange(e)}
                placeholder="Enter Payment Amount"
              />
            </div>

            <div className="BillBar-modal-input">
              <label htmlFor="payDate">Pay Date</label>
              <input
                type="date"
                id="payDate"
                className={`bill-remaining-input bill-remaining`}
                value={data.paydate}
                disabled={UserDetails.canBckDateEntry}
                name="paydate"
                onChange={(e) => handlechange(e)}
              />
            </div>

            <div className="BillBar-modal-input">
              <label htmlFor="payBy">Pay Mode</label>
              {/* <input
              type="text"
              id="payBy"
              name="payby"
              className={`bill-remaining-input bill-remaining`}
              value={data.payby}
              onChange={(e) => handlechange(e)}
              placeholder="Enter Payment Method"
            /> */}
              <select
                name="payby"
                onChange={handlechange}
                className={`bill-remaining-input bill-remaining`}
              >
                <option>--select--</option>
                {data?.payby?.map((item) => {
                  return (
                    <option className={`option-for-paymode`} value={item.id}>
                      {item?.name}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="BillBar-modal-input">
              <label htmlFor="remarks">Remarks</label>
              <textarea
                id="remarks"
                className={`bill-remaining-input bill-remaining`}
                value={data.remarks}
                name="remarks"
                onChange={(e) => handlechange(e)}
                placeholder="Enter Remarks"
              />
            </div>
          </div>
        ) : (
          <div className={`table-data-div`}>
            <table>
              <thead>
                {/* <th className={`thead-pay`}>MasterType Name</th> */}
                <th className={`thead-pay`}>Voucher Info</th>
                <th className={`thead-pay`}>Account Name</th>
                <th className={`thead-pay`}>Amount</th>
                <th className={`thead-pay`}>Paid Date</th>
                <th className={`thead-pay`}>Remarks</th>
                <th className={`thead-pay`}>Action</th>
              </thead>
              {historydata.map((item, index) => {
                return (
                  <tr>
                    {/* <td className={`td-pay`}>{item?.masterTypeName}</td> */}
                    <td
                      className={`td-pay`}
                    >{`${item?.vouchSeriesName}:${item.vouchNo}`}</td>
                    <td className={`td-pay`}>{item?.accName}</td>
                    <td className={`td-pay`}>{Math.abs(item?.value1)}</td>
                    <td className={`td-pay`}>{item?.paidDate}</td>
                    <td className={`td-pay`}>{item?.shortNarration}</td>
                    <td className={`td-pay`}>
                      <span
                        onClick={() =>
                          deletehandle(masterType, TransId, item.paidRemId)
                        }
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                        }}
                      >
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
        )}

        <div className="mt-4" style={{ textAlign: "center" }}>
          <button
            disabled={SubmitButtonDisable}
            onClick={handleSubmit}
            className="BillBar-modal-close-btn"
          >
            SUBMIT
          </button>
        </div>
      </div>
    </div>
  );
};

export default PayRemainingBill;
